<template>
    <Main>
        <v-container>
            <v-row justify="center">
                <v-col cols="12">
                    <v-card class="pa-5">
                        <v-row dense>
                            <v-col cols="12">
                                <strong>Overview Location Relasi</strong>
                            </v-col>
                        </v-row>
                        <hr />
                        <v-row class="mt-4">
                            <v-col cols="3" md="3">
                                <v-select 
                                    color="red darken-1" 
                                    v-model="SELECTED_BRANCH" 
                                    :items="VSELECT_BRANCH" 
                                    item-text="BRANCH_CODE" 
                                    item-value="BRANCH_CODE" 
                                    label="Select Branch" 
                                    dense 
                                    outlined></v-select>
                            </v-col>
                            <v-col cols="3" md="3">
                                <v-select 
                                    color="red darken-1" 
                                    v-model="SELECTED_CHANNEL" 
                                    :items="VSELECT_CHANNEL" 
                                    item-text="SALES_CHANNEL_GROUP" 
                                    item-value="SALES_CHANNEL_GROUP" 
                                    label="Select Channel" 
                                    dense 
                                    outlined></v-select>
                            </v-col>
                            <v-col cols="3" md="3">
                                <v-btn @click="selectBranchChannel" color="error" :disabled="dtLoading">
                                Load List</v-btn>
                            </v-col>
                            <v-col class="text-right" cols="6">
                                <v-text-field
                                color="red darken-1"
                                v-model="dtSearch"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                class="pa-0"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- Data Table -->
                        <v-row>
                            <v-col cols="12">
                                <v-card class="pa-3" outlined>
                                    <v-data-table
                                        :headers="dtHeaders"
                                        :items="dtItems"
                                        :search="dtSearch"
                                        :loading="dtLoading"
                                        loading-text="Fetching Data..."
                                    >

                                    <template v-slot:item.VIEW_DEKAT="{ item }">
                                        <v-icon small class="mr-2" @click="previewImage(item.TD)">mdi-eye</v-icon>
                                    </template>
                                    <template v-slot:item.VIEW_JAUH="{ item }">
                                        <v-icon small class="mr-2" @click="previewImage(item.TJ)">mdi-eye</v-icon>
                                    </template>
                                    <template v-slot:item.VIEW_MAPS="{ item }">
                                        <v-icon small class="mr-2" @click="previewMaps(item.LATITUDE, item.LONGITUDE)">mdi-eye</v-icon>
                                    </template>
                                    </v-data-table>

                                    <!-- GMaps -->
                                    <GmapMap
                                    v-if="showBigMap"
                                    v-model="showBigMap"
                                    ref="gmap"
                                    :center="markerCenter"
                                    :zoom="11"
                                    map-type-id="roadmap"
                                    style="width: 100%; height: 400px"
                                    >
                                        <GmapMarker
                                            :key="index"
                                            v-for="(m, index) in markerList"
                                            :position="m.position"
                                            :clickable="true"
                                            @click="openMarker(m.position)"
                                        >
                                            <GmapInfoWindow
                                                :closeclick="true"
                                                @closeclick="openMarker(null)"
                                                :opened="openedMarkerID === m.position"
                                            >
                                                <div class="font-weight-bold">{{ m.name }}</div>
                                            </GmapInfoWindow>
                                        </GmapMarker>
                                    </GmapMap>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- SNACKBAR -->
        <v-snackbar v-model="isShowSnackbar" top timeout="2000">{{ snackbarText }}</v-snackbar>

        <!-- MAPS MODAL -->
        <v-row justify="center">
            <v-dialog
                v-if="isShowMap"
                v-model="isShowMap"
                width="auto">
                <v-card>
                    <v-toolbar dark color="warning">
                        <v-btn icon dark @click="isShowMap = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Map Location</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="isShowMap = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-container fluid>
                        <iframe
                            width="600"
                            height="450"
                            style="border:0"
                            loading="lazy"
                            allowfullscreen
                            referrerpolicy="no-referrer-when-downgrade"
                            :src="mapSrc">
                        </iframe>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- IMAGE MODAL -->
        <v-row justify="center">
            <v-dialog
                v-if="isShowImage"
                v-model="isShowImage"
                width="auto"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="warning">
                        <v-btn icon dark @click="isShowImage = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Image</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="isShowImage = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-container fluid>
                        <v-img
                            :src="imageSrc"
                            width="300px"
                        >
                        </v-img>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>
    </Main>
</template>

<script>
    import Main from "@/Main.vue";
    import moment from "moment";
    import AWS from "aws-sdk";
    import {S3_CONNECTION} from "../../lib/config";

    const s3 = new AWS.S3(S3_CONNECTION);

    const dtHeaders = [
    {
        text: "Branch",
        value: "BRANCH_CODE",
    },
    {
        text: "Customer ID",
        value: "CUSTOMER_ID_REF",
    },
    {
        text: "Customer Name",
        value: "CUSTOMER_NAME",
    },
    {
        text: "Address",
        value: "ADDRESS"
    },
    {
        text: "Scan By",
        value: "USER_ID_UPDATE",
    },
    {
        text: "Date Scan",
        value: "LAST_UPDATE",
    },
    {
        text: "Notes",
        value: "NOTE",
    },
    {
        text: "Tampak Dekat",
        value: "VIEW_DEKAT",
    },
    {
        text: "Tampak Jauh",
        value: "VIEW_JAUH",
    },
    {
        text: "View Maps",
        value: "VIEW_MAPS",
    },
    ];

    export default {
        components: {
            Main,
        },
        data() {
            return {
                isShowSnackbar: false,
                snackbarText: "",
                dtSearch: "",
                dtLoading: false,
                dtHeaders,
                dtItems: [],
                VSELECT_BRANCH: [],
                SELECTED_BRANCH: "",
                VSELECT_CHANNEL: [],
                SELECTED_CHANNEL: "",
                isShowMap: false,
                isShowImage: false,
                showBigMap: false,
                markerList: [],
                markerCenter: [],
                openedMarkerID: null,
                mapSrc: "",
                imageSrc: "",
            }
        },
        mounted() {
            this.prepareDataBranch();
            this.prepareDataChannel();
        },
        methods: {
            prepareDataBranch() {
                this.dtLoading = true;
                this.$http
                    .get("/mapping-sales-assignment/selectBranchSales", {
                        headers: {
                            "api-key": this.$apiKey
                        }
                    })
                    .then(res => {
                        this.dtLoading = false;
                        let { data } = res.data;

                        data.unshift({
                            ORG_ID: -1,
                            BRANCH_CODE: "ALL",
                            BRANCH_DESC: "ALL", 
                        });
                        this.branch = data[0];
                        this.VSELECT_BRANCH = data;
                        // const data = res.data.data;
                        // this.VSELECT_BRANCH = data;
                    });
            },
            prepareDataChannel() {
                this.dtLoading = true;
                this.$http
                    .get("/mapping-sales-assignment/selectChannelSales", {
                        headers: {
                            "api-key": this.$apiKey
                        }
                    })
                    .then(res => {
                        this.dtLoading = false;
                        let { data } = res.data;

                        data.unshift({
                            SALES_CHANNEL_GROUP: "ALL" 
                        });
                        this.channel = data;
                        this.VSELECT_CHANNEL = data;
                    });
            },
            selectBranchChannel() {
                if(this.SELECTED_BRANCH == '') {
                    this.showSnackbar('Silakan pilih Branch terlebih dahulu');
                    return;
                } else if(this.SELECTED_CHANNEL == '') {
                    this.showSnackbar('Silahkan pilih Channel terlebih dahulu');
                    return;
                }
                
                let data = {
                    BRANCH_CODE: this.SELECTED_BRANCH,
                    SALES_CHANNEL_GROUP: this.SELECTED_CHANNEL
                }
                
                this.showBigMap = false;
                this.dtLoading = true;
                try {
                    this.$http
                        .post("/mapping-sales-assignment/overviewBranchSales", data, {
                            headers: {
                                "api-key": this.$apiKey
                            }
                        })
                        .then((res) => {
                            if(!res.data.success || res.data.success == undefined) {
                                console.log(res);
                            }
                            let { data } = res.data;
                            if (data.length <= 0) {
                                this.dtLoading = false;
                                this.dtItems = [];
                                return;
                            }

                            data.forEach((obj, index) => {
                                data[index].LAST_UPDATE = moment(data[index].LAST_UPDATE).locale('id').format(
                                "DD MMMM YYYY HH:mm"
                                );
                                data[index].LATITUDE = parseFloat(data[index].LATITUDE);
                                data[index].LONGITUDE = parseFloat(data[index].LONGITUDE);
                            });

                            let tempLatLng = data.map(obj => ({
                                name: obj.CUSTOMER_NAME,
                                lat: obj.LATITUDE,
                                lng: obj.LONGITUDE
                            }));

                            this.getMarkers(tempLatLng);
                            this.showBigMap = true;
                            this.dtLoading = false;
                            this.dtItems = data;
                        });
                } catch (error) {
                    this.dtLoading = false;
                    this.showSnackbar(err.toString());
                }

            },
            getMarkers(data) {
                this.markerList = [];
                this.markerCenter = data[0];
                for(let i=0;i<data.length;i++){
                    this.markerList.push({
                        name: data[i]["name"],
                        position: data[i],      
                    });
                }
            },
            openMarker(id) {
                this.openedMarkerID = id
            },
            async previewImage(item) {
                const params = {
                    Bucket: S3_CONNECTION.accessKeyId,
                    Key: item
                }
                const imageSrc = await s3.getObject(params).promise();
                this.imageSrc = `data:image/jpeg;base64,${imageSrc.Body.toString('base64')}`;
                this.isShowImage = true;
            },
            previewMaps(lat, lng) {
                this.isShowMap = true;
                this.mapSrc = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBiapGKGLf6NCzdMIEg_zt4HB5EYL2f20Q&q='+lat+','+lng+'&zoom=18';
            },
            showSnackbar(text) {
                this.snackbarText = text;
                this.isShowSnackbar = true;
            }
        }
    }
</script>